import { action } from 'typesafe-actions'

import {
  FoodPriceHistory,
  FoodPriceHistoryPagination,
  FoodPriceHistoryParam,
} from './food-price-histories'

export enum foodPriceHistoryActionType {
  FETCH_FOOD_PRICE_HISTORIES = 'FOOD_PRICE_HISTORY/FETCH_FOOD_PRICE_HISTORIES',
  FETCH_FOOD_PRICE_HISTORIES_SUCCEEDED = 'FOOD_PRICE_HISTORY/FETCH_FOOD_PRICE_HISTORIES_SUCCEEDED',
  THROW_ERROR = 'FOOD_PRICE_HISTORY/THROW_ERROR',
}

export const foodPriceHistoryActions = {
  fetchFoodPriceHistories: (param: FoodPriceHistoryParam) =>
    action(foodPriceHistoryActionType.FETCH_FOOD_PRICE_HISTORIES, param),
  fetchFoodPriceHistoriesSucceeded: (
    histories: FoodPriceHistory[],
    pagination: FoodPriceHistoryPagination
  ) =>
    action(foodPriceHistoryActionType.FETCH_FOOD_PRICE_HISTORIES_SUCCEEDED, {
      histories,
      pagination,
    }),
  throwError: (error: Error) =>
    action(foodPriceHistoryActionType.THROW_ERROR, { error }),
}
